export default function About() {
  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff5a00] mb-3">Meistä</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight max-w-3xl leading-[0.95]">
          Käytettyjen autojen erikoisliike Lahdessa.
        </h1>

        <div className="max-w-3xl space-y-6 text-white/70 leading-relaxed mt-12 text-lg">
          <p>
            Lahden Autokulma on lahtelainen käytettyjen autojen liike, joka tarjoaa laajan ja
            vaihtuvan valikoiman vaihtoautoja. Valikoimamme kattaa niin arjen
            perheautot kuin harvinaisemmat klassikotkin.
          </p>
          <p>
            Autamme sinua koko ostoprosessin ajan — rahoituksesta vaihtoauton arviointiin.
            Kaikki myynnissä olevat autot näkyvät tällä sivustolla reaaliajassa, ja poistuvat
            heti kun ne on myyty.
          </p>
        </div>

        <div className="grid grid-cols-2 max-w-lg gap-px bg-white/10 border border-white/10 mt-12">
          {[["30+", "vuotta"], ["2000+", "myytyä autoa"]].map(([n, l]) => (
            <div key={l} className="bg-[#050505] p-8">
              <p className="font-display text-4xl text-[#ff5a00]">{n}</p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-white/50 mt-1">{l}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
